export default __webpack_public_path__ + "static/media/hand-platter-lunch.d66975c5.png";